import React from "react";
import { Stack } from "@mui/material";
import { useParams } from "react-router-dom";
import GestionCompetitionNav from "./GestionCompetitionNav";

const GestionCompetitionLayout = ({ children }) => {
  const { id: competitionId } = useParams();

  return (
    <Stack spacing={2} sx={{ width: "100%" }}>
      <GestionCompetitionNav competitionId={competitionId} />
      {children}
    </Stack>
  );
};

export default GestionCompetitionLayout;
